import React, { useEffect, useState } from 'react';
import { Button, Drawer, Form, Input, message, Select } from 'antd';
import { dispatch, useGlobalState } from '../../../store/state';
import './BrandProfileComponent.styles.scss';
import { GetProfileDetails } from '../../../apis/Brand/Profile/GetProfileDetails';
import { UpdateProfileDetails } from '../../../apis/Brand/Profile/UpdateProfileDetails';
import { AppLogout } from '../../../utils/AppLogout';
import BrandBillingDetails from './BrandBillingDetails';

const { Item } = Form;
const BrandProfileComponent = ({ visible, onClose }) => {
  const [user] = useGlobalState('user');
  // const [profileBasicForm] = Form.useForm()
  useEffect(()=>{
    GetProfileDetails(user.accessToken).then(({ response, status }) =>{
      console.log('prof response', response);
      if (status === 200) {
        dispatch({
          type: 'SET_USER',
          payload: {
            ...user,
            email: response.email,
            phone: response.phone,
            gst: response.gst,
            address: response.address,
            pan: response.pan || undefined,
          },
        });
      } else if (status === 404) {
        AppLogout();
      } else {
        message.error('There is some issue with getting your profile details');
      }
    });
  }, []);

  // @note: to update basic details of profile
  const onProfileBaseUpdate = (_v) =>{
    const _data = {
      firstname: _v.firstname,
      lastname: _v.lastname,
    };
    UpdateProfileDetails(user.accessToken, _data).then(({ status })=>{
      if (status === 200) {
        dispatch({
          type: 'SET_USER',
          payload: {
            ...user,
            ..._data,
          },
        });
        message.success('Profile Updated Successfully!');
      } else {
        message.success('There is some issue with your profile update');
      }
    });
  };
  return (
    <Drawer
      width={650}
      title="Edit your profile"
      visible={visible}
      onClose={onClose}
    >
      <div className="profile_basics my-2">
        <div className="d-flex flex-wrap">
          <div className="col-md-5">
            <div className="profile_img text-left mb-3">
              <img src={user.profilepicture}
                className="img-fluid"
                alt="" />
            </div>
            <h4 className="profile_basics--title">User Information</h4>
            <Form
              // form={profileBasicForm}
              onFinish={onProfileBaseUpdate}
              className="profile_basics_form"
              name="profileBasicForm"
              layout="vertical"
              requiredMark={false}
              initialValues={{
                'firstname': user.firstname,
                'lastname': user.lastname,
                'email': user.email,
                // "phonePrefix":"+91",
                'phone': user.phone,

              }}
            >
              <Item
                label="User first name"
                name="firstname"
                rules={[
                  { required: true, message: 'This field can\'t be empty' },
                ]}
              >
                <Input className="common_input"
                  placeholder="Your first name"/>
              </Item>
              <Item
                label="User first name"
                name="lastname"
                rules={[
                  { required: true, message: 'This field can\'t be empty' },
                ]}
              >
                <Input className="common_input"
                  placeholder="Your last name"/>
              </Item>
              <Item
                label="Official Email"
                name="email"
              >
                <Input disabled
                  className="common_input"
                  type="email"
                  placeholder="Your Email ID"/>
              </Item>
              <Item
                label="Phone number"
                name="phone"
                rules={[
                  { required: true, message: 'This field can\'t be empty' },
                ]}
              >
                <Input
                  className="common_input"
                  disabled
                  type="tel"
                  placeholder="Your Phone number"
                />
              </Item>
              <Item>
                <Button htmlType="submit"
                  className="common_button outlined mt-2 py-2 w-100">Save Changes</Button>
              </Item>
            </Form>
          </div>
          <div className="col-md-7">
            <BrandBillingDetails/>
          </div>
        </div>
      </div>
    </Drawer>
  );
};

export default BrandProfileComponent;
